<template>
  <button class="btn-green btn-sm flex-shrink-0" @click="$root.$emit('bv::toggle::modal', 'addSponsorModal')">
      <span>+ Add Sponsor</span>
      <sponsor-modal v-on:added-sponsor="$emit('added-sponsor', $event)" modalId="addSponsorModal" :levels="levels"/>
  </button>
</template>
<script>
import SponsorModal from './SponsorModal.vue'

export default {
  components: {
    SponsorModal
  },
  props: {
    levels: {
      type: Array,
      default: () => []
    }
  }
}
</script>
